import RibbonsContainer from "../../../Component/BonusUi/Ribbons/Ribbons"

const Ribbons = () => {
  return (
    <div className='page-body'>
      <RibbonsContainer />
    </div>
  )
}

export default Ribbons